import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { EmailTemplatesVM } from './email-templates.viewmodel';

const EmailTemplatesContext = React.createContext<EmailTemplatesVM>(null);
const connectEmailTemplatesVM = makeConnect(EmailTemplatesContext);

export { EmailTemplatesContext, connectEmailTemplatesVM };